import ReferenceSearch from './ReferenceSearch'

export default ReferenceSearch
